
import bootstrap from '../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js';
import { createPopper } from '@popperjs/core';
import GLightbox from 'glightbox';
import flatpickr from "flatpickr";
import { Russian } from "flatpickr/dist/l10n/ru.js"
import Swiper, {Navigation, Pagination, EffectCards, EffectCreative, EffectFade, EffectFlip} from 'swiper';
Swiper.use([Navigation, EffectCards,EffectCreative,EffectFade,EffectFlip]);
import LazyLoad from "vanilla-lazyload";
import './scss/app.scss';
import { WOW } from 'wowjs';
new WOW().init();
let MagicGrid = require("magic-grid");
var lazyLoadInstance = new LazyLoad({
    elements_selector: '.lazyload'
    // Your custom settings go here
});
const lightbox = GLightbox();
document.addEventListener("DOMContentLoaded", function(event) {
    reinit(document);
});
var canvlist = {};
var myMap = false;
var canvactive = 0;
const toastLiveExample = document.getElementById('liveToast');
const toast = new bootstrap.Toast(toastLiveExample);
var styles = {
    default: null,
    silver: [],


    hiding: [
        {
            "featureType": "all",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "saturation": 36
                },
                {
                    "color": "#000000"
                },
                {
                    "lightness": 40
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#000000"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 17
                },
                {
                    "weight": 1.2
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 21
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 17
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 29
                },
                {
                    "weight": 0.2
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 18
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 19
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 17
                }
            ]
        }
    ]
};
var map;
function reinit(obj) {
    if (obj) {
        ActivateLinks(obj);
    }
}
function ActivateLinks(obj) {
    if (document.querySelector('.lead-form')) {
        var forms = document.querySelectorAll('.lead-form');
        for (var i = 0; i < forms.length; i++) {
            forms[i].addEventListener('submit',sendForm,false);
        }

    }
    if (document.querySelector('.full-swiper')) {
        var interleaveOffset = 1;

        var swiperOptions = {
            loop: true,
            speed: 1000,
            grabCursor: true,
            watchSlidesProgress: true,
            mousewheelControl: true,
            keyboardControl: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            on: {
                progress: function(swip, progress) {
                    for (var i = 0; i < swip.slides.length; i++) {
                        var slideProgress = swip.slides[i].progress;
                        var innerOffset = swip.width * interleaveOffset;
                        var innerTranslate = slideProgress * innerOffset;
                        swip.slides[i].querySelector(".slide-inner-body").style.transform =
                            "translate3d(" + innerTranslate + "px, 0, 0)";
                    }
                },
                beforeTransitionStart: function (swip,speed,internal) {
                    for (var i = 0; i <  swip.slides.length; i++) {
                        swip.slides[i].style.transition = "";
                    }
                },
                setTransition: function(swip,speed) {
                    for (var i = 0; i < swip.slides.length; i++) {
                        swip.slides[i].style.transition = speed + "ms";
                        swip.slides[i].querySelector(".slide-inner-body").style.transition =
                            speed + "ms";
                    }
                }
            }
        };
        // var interleaveOffset = 1;
        //
        // var swiperOptions = {
        //     loop: true,
        //     speed: 1000,
        //     // effect: 'fade',
        //     grabCursor: true,
        //     watchSlidesProgress: true,
        //     mousewheelControl: true,
        //     keyboardControl: true,
        //     modules: [Navigation],
        //     navigation: {
        //         nextEl: ".swiper-button-next",
        //         prevEl: ".swiper-button-prev"
        //     },
        // };

        const swiper = new Swiper(".full-swiper", swiperOptions);
    }
    if (document.querySelector('.command-swiper')) {
        var interleaveOffset = 1;

        var swiperOptions = {
            loop: true,
            speed: 1000,
            grabCursor: true,
            watchSlidesProgress: true,
            mousewheelControl: true,
            keyboardControl: true,
            navigation: {
                nextEl: ".swiper-command-button-next",
                prevEl: ".swiper-command-button-prev"
            },
            on: {
                progress: function(swip, progress) {
                    for (var i = 0; i < swip.slides.length; i++) {
                        var slideProgress = swip.slides[i].progress;
                        var innerOffset = swip.width * interleaveOffset;
                        var innerTranslate = slideProgress * innerOffset;
                        swip.slides[i].querySelector(".slide-inner-body").style.transform =
                            "translate3d(" + innerTranslate + "px, 0, 0)";
                    }
                },
                beforeTransitionStart: function (swip,speed,internal) {
                    for (var i = 0; i <  swip.slides.length; i++) {
                        swip.slides[i].style.transition = "";
                    }
                },
                setTransition: function(swip,speed) {
                    for (var i = 0; i < swip.slides.length; i++) {
                        swip.slides[i].style.transition = speed + "ms";
                        swip.slides[i].querySelector(".slide-inner-body").style.transition =
                            speed + "ms";
                    }
                }
            }
        };
        // var interleaveOffset = 1;
        //
        // var swiperOptions = {
        //     loop: true,
        //     speed: 1000,
        //     // effect: 'fade',
        //     grabCursor: true,
        //     watchSlidesProgress: true,
        //     mousewheelControl: true,
        //     keyboardControl: true,
        //     modules: [Navigation],
        //     navigation: {
        //         nextEl: ".swiper-button-next",
        //         prevEl: ".swiper-button-prev"
        //     },
        // };

        const swiper = new Swiper(".command-swiper", swiperOptions);
    }
    if (document.querySelector('.swiper-rows')) {
        var interleaveOffset = 1;

        var swiperOptions = {
            loop: true,
            speed: 1000,
            // effect: 'fade',
            slidesPerView: 4,
            // virtualTranslate: true,
            slidesPerGroup: 4,
            grabCursor: true,
            watchSlidesProgress: true,
            mousewheelControl: true,
            keyboardControl: true,
            modules: [Navigation],
            breakpoints: {
                // when window width is >= 320px
                120: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                },
                // when window width is >= 480px
                576: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
                // when window width is >= 640px
                993: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                }
            },
            on: {
                beforeSlideChangeStart: function (swip,speed,internal) {
                        for (var i = 0; i < swip.slides.length; i++) {
                            swip.slides[i].classList.add('ready-slide');
                        }

                },
                beforeTransitionStart: function (swip,speed,internal) {
                    for (var i = 0; i < swip.slides.length; i++) {
                        swip.slides[i].classList.add('opacity-0');
                        swip.slides[i].classList.add('ready-slide');
                        swip.slides[i].querySelector(".white-icon").classList.add('py-5');
                    }
                },
                transitionEnd: function (swip) {
                    for (var i = 0; i < swip.slides.length; i++) {
                        swip.slides[i].classList.remove('opacity-0');
                        swip.slides[i].querySelector(".white-icon").classList.remove('py-5');
                    }
                },
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },

        };

        const swiper = new Swiper(".swiper-rows", swiperOptions);
    }
    if (document.querySelector('[data-bs-toggle="tooltip"]')) {
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
    }
    if (document.querySelector('.set-currency-link')) {
        var currlinks = document.querySelectorAll('.set-currency-link');
        for (var i = 0; i < currlinks.length; i++) {
            currlinks[i].addEventListener('click',setCurrency,false);
        }
    }
    if (document.querySelector('.drop-max')) {
        var withoutCanvlinks = document.querySelectorAll('.header .toggle-canv');
        for (var i = 0; i < withoutCanvlinks.length; i++) {
            withoutCanvlinks[i].addEventListener('mouseenter',hideCanvas,false);
        }
        var withoutCanvBodys = document.querySelectorAll('.drop-canvas');
        for (var i = 0; i < withoutCanvBodys.length; i++) {
            withoutCanvBodys[i].addEventListener('mouseleave',hideCanvasBody,false);
        }


    }
    if (document.querySelector('.select-country')) {
        var countrylinks = document.querySelectorAll('.select-country');
        for (var i = 0; i < countrylinks.length; i++) {
            countrylinks[i].addEventListener('click',selectCountry,false);
        }
    }
    if (document.querySelector('input[type="tel"]')) {
        var telInputs = document.querySelectorAll('input[type="tel"]');
        for (var i = 0; i < telInputs.length; i++) {
            telInputs[i].addEventListener('paste',regPhone,false);
            telInputs[i].addEventListener('keyup',regPhone,false);
        }
    }
    if (document.getElementById('map')) {
        initialize();
    }
}
function selectCountry(e) {
    e.preventDefault();
    var dial = e.currentTarget.dataset.dial;
    var country = e.currentTarget.dataset.country;
    var btn = e.currentTarget.parentNode.parentNode.parentNode.querySelector('.dropdown-toggle span');
    btn.classList.remove('flag-icon-'+btn.dataset.country);
    btn.classList.add('flag-icon-'+country);
    e.currentTarget.parentNode.parentNode.parentNode.parentNode.querySelector('input').value = '+'+dial;
}
function regPhone(e) {
    let regex = /[^\d\+]/g;
    let regex2 = /\d\+/g;
    e.target.value = e.target.value.replace(regex, '').replace(regex2,'');
}
function sendForm(e) {
    e.preventDefault();
    var form = e.currentTarget;
    var data =  new FormData(form);
    var request = new XMLHttpRequest();
    var link = '/lead-form/';
    request.open("POST", link, true);
    // request.setRequestHeader("Content-Type", "application/json");
    // request.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    request.send(data);
    request.onreadystatechange = function () {
        if (request.readyState === 4 && request.status === 200) {
            var data = JSON.parse(request.response);
            if (data.error) {
                var inputs = form.querySelectorAll('input,select,textarea');
                for (var i = 0; i < inputs.length; i++) {
                    var name = inputs[i].getAttribute("name");
                    if (data.errors.hasOwnProperty(name)) {
                        inputs[i].classList.add('is-invalid');
                    } else {
                        inputs[i].classList.remove('is-invalid');
                    }
                }

            } else {
                var inputs = form.querySelectorAll('input,select,textarea');
                for (var i = 0; i < inputs.length; i++) {
                        inputs[i].classList.remove('is-invalid');
                        var type = inputs[i].getAttribute('type');
                        if (type ==='text' || type ==='tel' || type ==='email' || inputs[i].tagName == 'TEXTAREA') {
                            inputs[i].value = '';
                        }
                }
                bootstrap.Modal.getOrCreateInstance(document.getElementById('rentModal')).hide();
                bootstrap.Modal.getOrCreateInstance(document.getElementById('buyModal')).hide();
                bootstrap.Modal.getOrCreateInstance(document.getElementById('requestModal')).hide();

                toastLiveExample.querySelector('.toast-body').innerHTML = form.querySelector('.after-message').innerHTML;
                toast.show();

            }
        };
    };
}

function hideCanvas(e) {
    if (e.currentTarget.classList.contains('drop-max')) {
        var id = e.currentTarget.dataset.id;
        if (canvactive !== 0) {
            bootstrap.Offcanvas.getOrCreateInstance(document.getElementById('submenu-'+canvactive)).hide();
        }
        bootstrap.Offcanvas.getOrCreateInstance(document.getElementById('submenu-'+id)).show();
        document.querySelector('.header').classList.add('scroll-header');
        canvactive = parseInt(id);
    } else {
        if (canvactive !== 0) {
            bootstrap.Offcanvas.getOrCreateInstance(document.getElementById('submenu-'+canvactive)).hide();
            canvactive = 0;
        }
    }
}
function hideCanvasBody(e) {
        if (canvactive !== 0) {
            bootstrap.Offcanvas.getOrCreateInstance(document.getElementById('submenu-'+canvactive)).hide();
            canvactive = 0;
        }
}
let lastKnownScrollPosition = 30;
let ticking = false;
function doSomething(scrollPos) {
    // Do something with the scroll position
}
document.addEventListener("scroll", (event) => {
    var positionScroll = window.scrollY;
    if (positionScroll > lastKnownScrollPosition && positionScroll > 50) {
        hideHeader();
    } else {
        showHeader();
    }
    initHeader();
    lastKnownScrollPosition = window.scrollY;
});
function initHeader(){
    if (window.scrollY > 10) {
        if (!document.querySelector('.header').classList.contains('scrolled-header')) {
            document.querySelector('.header').classList.add('scrolled-header');
        }
    } else {
        document.querySelector('.header').classList.remove('scrolled-header');
    }
}
function hideHeader() {
    document.querySelector('.header').classList.add('scrolled-header');
}
function showHeader() {
    document.querySelector('.header').classList.remove('scrolled-header');
}


var map;
function initialize() {
    // Create the map with no initial style specified.
    // It therefore has default styling.
    var myLatlng = new google.maps.LatLng(55.679727,37.548779);

    map = new google.maps.Map(document.getElementById('map'), {
        center: myLatlng,
        zoom: 14,
        mapTypeControl: false,
        disableDefaultUI: true
    });


    var styleControl = document.getElementById('style-selector-control');

    var contentString = '<div class="row content-map"><div class="col-12"><h4 class="fs-5 text-gradient">3-STEPS.PRO</h4></div></div>';

    var infowindow = new google.maps.InfoWindow({
        content: contentString
    });


    var marker = new google.maps.Marker({
        position: myLatlng,
        icon: {
            url: "/images/logo-s.svg",
            scaledSize: new google.maps.Size(40, 60)
        },
        animation: google.maps.Animation.DROP,
        map: map,
        title: '3-steps.pro'
    });



    google.maps.event.addListener(marker, 'click', function() {
        toggleBounce
        infowindow.open(map,marker);
    });

    map.controls[google.maps.ControlPosition.TOP_LEFT].push(styleControl);

    map.setOptions({
        styles: styles.hiding,
        scrollwheel: false
    });

}
function toggleBounce() {

    if (marker.getAnimation() !== null) {
        marker.setAnimation(null);
    } else {
        marker.setAnimation(google.maps.Animation.BOUNCE);
    }

}

var styles = {
    default: null,
    silver: [],


    hiding: [
        {
            "featureType": "all",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "saturation": 36
                },
                {
                    "color": "#000000"
                },
                {
                    "lightness": 40
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#000000"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 17
                },
                {
                    "weight": 1.2
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 21
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 17
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 29
                },
                {
                    "weight": 0.2
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 18
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 19
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 17
                }
            ]
        }
    ]
};




